import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";
import { UserContext } from "./context";
import apiNotes from "../providers/notes";
import ApiAttendance from "../providers/attendance";
import ProgresoPlanillas from "../views/pages/notes/ProgresoPlanillas";

export const PlanillasDownloadContext = createContext();

export const usePlanillasDownload = () =>
  useContext(PlanillasDownloadContext);

export const PlanillasDownloadProvider = ({ children }) => {
  const { isSocket } = useContext(UserContext);
  const apiAttendance = ApiAttendance();

  const [descargando, setDescargando] = useState(false);
  const [progreso, setProgreso] = useState(null);
  const descargandoRef = useRef(false);

  useEffect(() => {
    if (!isSocket) return;

    const handleProgreso = (event) => {
      let mensaje;
      try {
        mensaje = JSON.parse(event.data);
      } catch (error) {
        return;
      }

      switch (mensaje.tipo) {
        case "planillas_progreso":
          setProgreso({
            fase: mensaje.fase,
            porcentaje: mensaje.porcentaje ?? 0,
            procesados: mensaje.procesados,
            total: mensaje.total,
            tiempoRestante: mensaje.tiempo_restante_seg,
            nombreGrupo: mensaje.nombre_grupo,
            totalPlanillas: mensaje.total_planillas,
          });
          break;
        case "planillas_completado":
          setProgreso(null);
          break;
        case "planillas_error":
          setProgreso(null);
          setDescargando(false);
          descargandoRef.current = false;
          toast.error(mensaje.mensaje || "Error al generar las planillas.");
          break;
        default:
          break;
      }
    };

    isSocket.addEventListener("message", handleProgreso);
    return () => isSocket.removeEventListener("message", handleProgreso);
  }, [isSocket]);

  const ejecutarDescarga = async (fn, params) => {
    if (descargandoRef.current) {
      toast.info("Ya hay una descarga masiva en curso.");
      return;
    }

    descargandoRef.current = true;
    setDescargando(true);
    setProgreso({ fase: "recoleccion", porcentaje: 0 });

    try {
      const res = await fn(params);
      if (res && res.success === false) {
        toast.error("No se pudo completar la descarga masiva.");
      } else {
        toast.success("La descarga masiva ha finalizado.");
      }
    } catch (error) {
      toast.error("No se pudo completar la descarga masiva.");
    } finally {
      descargandoRef.current = false;
      setDescargando(false);
      setProgreso(null);
    }
  };

  const iniciarDescargaMasivaTotal = (params) =>
    ejecutarDescarga(
      (p) => apiNotes.generarPlanillaMensualNotasMasivaTotal(p),
      params,
    );

  const iniciarDescargaAsistenciaMasivaTotal = (params) =>
    ejecutarDescarga(
      (p) => apiAttendance.generarPlanillaAsistenciaMasivaTotal(p),
      params,
    );

  const value = {
    descargando,
    progreso,
    iniciarDescargaMasivaTotal,
    iniciarDescargaAsistenciaMasivaTotal,
  };

  return (
    <PlanillasDownloadContext.Provider value={value}>
      {children}
      {descargando && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 2000,
            width: "320px",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(13, 35, 62, 0.18)",
            border: "1px solid #e5eaf0",
            padding: "16px 18px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "12px",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#0072FF",
              }}
            />
            <span
              style={{
                color: "#0D233E",
                fontWeight: 600,
                fontSize: "13px",
              }}
            >
              Generando planilla masiva…
            </span>
          </div>
          <ProgresoPlanillas progreso={progreso} />
          <p style={{ margin: 0, color: "#798696", fontSize: "11px" }}>
            Puede seguir navegando; le avisaremos cuando termine.
          </p>
        </div>
      )}
    </PlanillasDownloadContext.Provider>
  );
};